import type { SubIdProps } from "@/types/offers";

enum SubIdPart {
    SessionId = "SESSION_ID",
    UserId = "USER_ID",
    SiteShortCode = "SITE_SHORT_CODE",
    LastSessionId = "LAVI",
    ClickoutId = "CLICKOUT_ID",
};

const DEFAULT_SUB_ID_TEMPLATE = [
    SubIdPart.ClickoutId,
    SubIdPart.UserId,
    SubIdPart.SiteShortCode,
];

const parseSubIdTemplate = (envValue?: string): SubIdPart[] => {
    try {
        if (!envValue) return DEFAULT_SUB_ID_TEMPLATE;
        
        const parsed = JSON.parse(envValue);
        if (!Array.isArray(parsed)) return DEFAULT_SUB_ID_TEMPLATE;
        
        const validParts = parsed.filter((part): part is SubIdPart => 
            Object.values(SubIdPart).includes(part as SubIdPart)
        );
        
        return validParts.length ? validParts : DEFAULT_SUB_ID_TEMPLATE;
    } catch {
        return DEFAULT_SUB_ID_TEMPLATE;
    }
};

export const generateSubId = (
    subIdProps: SubIdProps,
    epcId: string,
    seperator?: string,
): string => {
    const separator = seperator ?? "_";
    const template = parseSubIdTemplate(process.env.SUB_ID_TEMPLATE);
    
    const partValues = {
        [SubIdPart.SessionId]: subIdProps.sessionCookie.sessionId,
        [SubIdPart.UserId]: subIdProps.userCookie.uuid,
        [SubIdPart.SiteShortCode]: subIdProps.shortCode,
        [SubIdPart.ClickoutId]: epcId,
        [SubIdPart.LastSessionId]: subIdProps.userCookie.lastAvailableVisitorId,
    };

    const parts = template.map(part => partValues[part] ?? '');
    return encodeURIComponent(parts.join(separator));
};

export const mergeOfferLink = (
    offerLink: string,
    epcId: string,
    subId: string
): string => {
    if (!offerLink) return '';
    return offerLink
        .replaceAll("${subId}", subId)
        .replaceAll("${epcId}", epcId)
        .replaceAll("${subId_epcId}", epcId);
};
